export const aboutContent = {
  title: "À propos de cette application",
  paragraphs: [
    "Cette application a été développée par Keudjo Benjamin et Shck Tchamna pour Resulam.",
    "Les données utilisées proviennent d'un script Python conçu par Shck Ca᷅mnà' (Tchamna), qui génère les jours de la semaine en langue Fe'efe'e, couvrant la période du 1er janvier 1900 au 31 décembre 2200. Grâce à ce fichier, il est également possible d'étendre le calendrier indéfiniment.",
    "Vous êtes libre d'utiliser cet outil pour générer le calendrier dans votre propre langue."
  ],
  links: {
    github: [
      {
        text: "Le code source du calendrier en CSV est disponible sous GitHub :",
        url: "https://github.com/tchamna/Bamileke/blob/main/CalendrierBamilekeCalendarNufi.ipynb",
        label: "Calendrier Bamileke en Fe'efe'e"
      },
      {
        text: "Le code source du calendrier en PDF est disponible sous GitHub :",
        url: "https://github.com/legrandBenjo/nufi-calendar-pdf-generator.git",
        label: "Générateur de calendrier en PDF"
      }
    ],
    contact: {
      text: "Pour signaler une erreur ou partager votre appréciation, veuillez nous contacter à l'adresse mail suivante:",
      email: "contact@resulam.com"
    }
  }
};